import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Role, RoleListResult, RolePermissions, UpdateRolePermissionRequest } from '../api/role/role';
import { BACKEND_URL } from '../app.config';

@Injectable()
export class RoleService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) {}

  getRoles(skipCount: number, maxResultCount: number): Observable<RoleListResult> {
    return this.http.get<RoleListResult>(`${this.baseUrl}/api/identity/roles`, {
      params: {
        skipCount,
        maxResultCount,
      },
    });
  }

  getAssignedRoles(): Observable<Role[]> {
    return this.http.get<{items: Role[]}>(`${this.baseUrl}/api/identity/users/assignable-roles`).pipe(
      map((result) => result.items.filter(role => !role.isStatic))
    );
  }

  getRole(id: string): Observable<Role> {
    return this.http.get<Role>(`${this.baseUrl}/api/identity/roles/${id}`);
  }

  addRole(role: Role): Observable<Role> {
    return this.http.post<Role>(`${this.baseUrl}/api/identity/roles`, role);
  }

  updateRole(role: Role): Observable<Role> {
    return this.http.put<Role>(`${this.baseUrl}/api/identity/roles/${role.id}`, role);
  }

  deleteRole(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api/identity/roles/${id}`);
  }

  getRolePermissions(roleName: string): Observable<RolePermissions> {
    return this.http.get<RolePermissions>(`${this.baseUrl}/api/permission-management/permissions`, {
      params: {
        providerName: 'R',
        providerKey: roleName,
      },
    });
  }

  updateRolePermissions(roleName: string, request: UpdateRolePermissionRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/api/permission-management/permissions`, request, {
      params: {
        providerName: 'R',
        providerKey: roleName,
      },
    });
  }
}
